import React from 'react';
import { EditableInfoComponent, Row } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { CountryClientTypeAddEditModal } from 'feature/countryTabs/pricing/clientTypePricingRules/edit';
import { useClientTypePricingRules } from 'feature/countryTabs/pricing/clientTypePricingRules/useClientTypePricingRules';
import { ClientTypePricingRuleCard } from 'feature/countryTabs/pricing/clientTypePricingRules/clinetTypePricingRuleCard';
import { Col } from 'antd';
import { DeleteModal } from 'feature/countryTabs/pricing/clientTypePricingRules/delete';
import { PricingRuleIcon } from 'components/common/icons';

export const ClientTypePricingRules = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { addModalState, clientTypePricingRuleId, onAddModalStateChange, onDeleteModalStateChange, clientTypeData } =
    useClientTypePricingRules();
  return (
    <>
      <EditableInfoComponent
        title={'Client Type Pricing Rules'}
        icon={<PricingRuleIcon />}
        creatable={hasAccess(PERMISSIONS.countries.client_pricing_rules.write)}
        editable={false}
        onAdd={onAddModalStateChange}
      />
      <Row>
        <Col span={24}>
          {clientTypeData.map((_data: Record<string, any>) => (
            <ClientTypePricingRuleCard key={_data.id} data={_data} onDeleteModalOpen={onDeleteModalStateChange} />
          ))}
        </Col>
      </Row>
      <CountryClientTypeAddEditModal onModalStateChange={onAddModalStateChange} modalState={addModalState} />
      <DeleteModal
        openModal={!!clientTypePricingRuleId}
        onDeleteModalClose={onDeleteModalStateChange}
        dataToDelete={{ id: clientTypePricingRuleId }}
      />
    </>
  );
});
